import axios, { AxiosResponse, InternalAxiosRequestConfig } from 'axios';

import { ResData } from '../types';
import { useUserDataStore } from '../store';

interface APIResponse<T> {
  data: null | T;
  success: boolean;
}

const httpClient = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL + '/api/v1',
});

httpClient.interceptors.request.use((config: InternalAxiosRequestConfig) => {
  const { accessToken } = useUserDataStore.getState();

  config.headers['Authorization'] = accessToken ? `Bearer ${accessToken}` : '';

  if (!config.url) return config;

  if (config.params) {
    const entries = Object.entries(config.params);
    const filteredEntries = entries.filter(([_, value]) => value !== '' && value !== undefined && value !== null);
    config.params = Object.fromEntries(filteredEntries);
  }

  return config;
});
httpClient.interceptors.response.use(
  (response: AxiosResponse<ResData<any>>) => {
    return {
      ...response,
      data: {
        data: response.data?.data || null,
        message: response.data?.message || '',
        success: true,
      } as APIResponse<any>,
    };
  },
  (error) => {
    return Promise.resolve({
      data: {
        data: null,
        message: error.response?.data?.message || '',
        success: false,
      } as APIResponse<any>,
    });
  }
);

export const API = httpClient;
